import {Resume} from './resume.d';

// tslint:disable
export default [
  {
    id: 'experience',
    label: 'Experience',
    content: [
      {
        id: 'software-engineer-factset',
        label: 'Software Engineer',
        at: 'FactSet Research Systems Inc.',
        link: 'https://factset.com/',
        location: 'New York, NY',
        time: 'Jul 2015 - Present',
        duration: '3 yrs',
        topic: ['tech', 'finance'],
        content: [
          {
            id: 'currently',
            title: 'Currently',
            content: [
              {
                id: '0',
                title: 'Wealth SBU - Portfolio Guide',
                body: [
                  `Lead engineer of Portfolio Guide (PG)`,
                  `DIY-style report creating app with drag-and-drop of any tiles to generate custom reports to each clients' need`,
                  `Built mid-layer resource manager to ease the burden of maintenance for static resources required by the app`,
                  `Built external modules for backend services that PG depends on which are now maintained by backend teams`,
                ],
              },
            ],
          },
          {
            id: 'previously',
            title: 'Previously',
            content: [
              {
                id: '0',
                title: 'Core Products (now Wealth SBU) - Developer Advocacy Group',
                body: [
                  `Lead effort in White-labeling (+$21M)`,
                  `Continue to deliver well-performing, yet stable, event-subscription-based library which helps the user to easily subscribe to RT backend service`,
                  `Advocate best practices and standards for code consistency across the board as well as for performance of individual apps`,
                  `Assert myself appropriately where help is needed`,
                ],
              },
              {
                id: '1',
                title: 'Core Products - RT Apps',
                body: [
                  `Build frontend core product applications with various and latest technologies available in the industry`,
                  `Lead engineer of an utility to create and modify a watchlist easily`,
                  `Lead engineer of an app which lets users to quickly view the global trend in a dynamic grid for a common stock using RT subscription`,
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'dsa-kalamazoo',
        label: 'Departmental Student Advisor (DSA)',
        at: 'Kalamazoo College',
        link: 'http://www.kzoo.edu/',
        location: 'Kalamazoo, MI',
        time: 'Sep 2014 - Jun 2015',
        duration: '10 mos',
        topic: ['tech', 'education'],
        content: [
          {
            id: '0',
            body: [
              `Chosen from senior department students to be promoted to Departmental Student Advisor`,
              `Attended first-year forums to represent the department and shared my own experiences`,
              `Answered questions for students and parents regarding my Senior Individualized Project and my motivation for choosing the major`,
            ],
          },
        ],
      },
      {
        id: 'ta kalamazoo',
        label: 'Teacher Assistant',
        at: 'Kalamazoo College',
        link: 'http://www.kzoo.edu/',
        location: 'Kalamazoo, MI',
        time: 'Sep 2013 - Jun 2015',
        duration: '1 yr 10 mos',
        topic: ['tech', 'education'],
        content: [
          {
            id: '0',
            body: [
              `Teacher assistant in Intro Computer Science/Programming/Physics courses helping students in labs and grading labs or assignments`,
            ],
          },
        ],
      },
      {
        id: 'shadow-health-system',
        label: 'Student Volunteer/Shadower',
        at: 'St. John Providence Health System',
        link: 'https://healthcare.ascension.org/Locations/Michigan/Detroit-Saint-John-Hospital',
        location: 'Detroit, MI',
        time: 'Aug 2012',
        duration: '1 mo',
        topic: ['health'],
        content: [
          {
            id: '0',
            body: [
              `Shadowed Dr. Casabar in NICU at St. John Hospital and Medical Center, experiencing the hospital environment, doctor’s job, and life style`,
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'education',
    label: 'Education',
    content: [
      {
        id: 'ba-kalamazoo',
        label: 'Bachelor of Arts',
        at: 'Kalamazoo College',
        link: 'http://www.kzoo.edu/',
        location: 'Kalamazoo, MI',
        time: 'Sep 2011 - Jun 2015',
        duration: '3 yrs 10 mos',
        topic: ['tech', 'math', 'education'],
        content: [
          {
            id: '0',
            title: 'Computer Science and Mathematics (3.86 in-major GPA)',
            body: [
              `Recent coursework includes: Mobile Computing & Discrete Math & Analysis of Algorithms & Operating Systems, Linear Algebra and Vectors & Calculus III & Complex and Vector Variables & Probability`,
              `DSA for Computer Science Department (2014-2015)`,
              `Health Guild is a group provides the connection with the Kalamazoo College Alumni works in the field`,
              `Organized and choreographed Gangnam Style dance in Asian Fest during winter for the theme, "Redefining Asia"`,
              `Designing an article using InDesign while actively interacting with other members`,
            ],
          },
          {
            id: '1',
            title: 'Courses',
            body: [
              `DB & Mobile Networking (COMP-498i)`,
              `Mobile Computing (COMP-489i)`,
              `Computer Networking & Internet (COMP-481)`,
              `Operating Systems & Networking (COMP-430)`,
              `Design & Analysis of Algorithms (COMP-215)`,
              `Data Structures (COMP-210)`,
              `Intro to Programming w/ Lab (COMP-110)`,
              `Mathematical Statistics (MATH-365)`,
              `Probability (MATH-362)`,
              `Real Analysis I (MATH-320)`,
              `Complex and Vector Variables (MATH-310)`,
              `Discrete Mathematics (MATH-250)`,
              `Linear Algebra and Vectors (MATH-240)`,
              `Calculus III (MATH-214)`,
            ],
          },
          {
            id: '2',
            title: 'Activities and Societies',
            body: [
              `Kalamazoo Health Guild`,
              `Kalamazoo Asian Society Association (ASA)`,
              `Kalamazoo Naked Music Magazine active Designer`,
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'volunteer-experience',
    label: 'Volunteer Experience',
    content: [
      {
        id: 'student-volunteer-sigcse',
        label: 'Student Volunteer',
        at: 'ACM SIGCSE',
        link: 'https://sigcse.org/sigcse/',
        location: 'Kansas City, MO',
        time: 'Mar 2015',
        duration: '1 mo',
        topic: ['tech', 'education'],
        content: [
          {
            id: '0',
            body: [
              `Served as a student volunteer to help ACM SIGCSE conference event to be ran smoothly`,
            ],
          },
        ],
      },
      {
        id: 'library-cart-uofm',
        label: 'Library Cart',
        at: 'University of Michigan Health System',
        link: 'https://www.uofmhealth.org/',
        location: 'Ann Arbor, MI',
        time: 'Jun 2010 - Feb 2011',
        duration: '9 mos',
        topic: ['health'],
        content: [
          {
            id: '0',
            body: [
              `Served for Library Cart in Michigan University Hospital Volunteer Services, encouraged and interacted with the patients by recommending books and magazines to read`,
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'skill',
    label: 'Skill',
    content: [
      {
        id: 'programing-languages',
        label: 'Programming Languages',
        topic: ['tech'],
        content: [
          {
            id: 'proficient',
            title: 'Proficient',
            content: [
              {
                id: '0',
                title: 'Javascript (ES5, ES6)',
                body: [
                  `AngularJS, VueJS, NodeJS, Redux, Lodash, Express, JQuery`,
                  `Gulp, Webpack, Grunt, Yarn, Bower, Yeoman`,
                ],
              },
              {
                id: '1',
                title: 'CSS',
                body: [
                  `SCSS/SASS, Less`,
                ],
              },
              {
                id: '2',
                title: 'HTML',
              },
              {
                id: '3',
                title: 'Markdown',
                body: [
                  `GitHub flavored, CommonMark`,
                ],
              },
            ],
          },
          {
            id: 'intermediate',
            title: 'Intermediate Proficient',
            content: [
              {
                id: '0',
                title: 'Database',
                body: [
                  `Redis, Swift Object Store, MongoDB`,
                ],
              },
              {
                id: '1',
                title: 'Build',
                body: [
                  `Jenkins, FactSet.io (Heroku)`,
                ],
              },
              {
                id: '2',
                title: 'Java',
                body: [
                  `Android API`,
                ],
              },
              {
                id: '3',
                title: 'Matlab',
              },
              {
                id: '4',
                title: 'LaTex',
              },
              {
                id: '5',
                title: 'XML',
              },
              {
                id: '6',
                title: 'C',
              },
              {
                id: '7',
                title: 'MySQL',
              },
              {
                id: '8',
                title: 'R',
              },
              {
                id: '9',
                title: 'PHP',
              },
            ],
          },
        ],
      },
      {
        id: 'others',
        label: 'Others',
        topic: ['misc'],
        content: [
          {
            id: 'proficient',
            title: 'Proficient',
            body: [
              `English`,
              `Korean`,
            ],
          },
        ],
      },
    ],
  },
] as Resume;



// WEBPACK FOOTER //
// ./src/components/about/resume.ts